import { Fragment } from 'react';
import cx from 'classnames';
import { Link } from '../../configs/routes';
import styles from '../../styles/tabs.scss';
import Loader from './Loader';

interface Item {
  key?: string;
  label?: string;
  href?: string;
  link?: boolean;
  selected?: boolean;
  subLinksLoading?: boolean;
  subLinks?: Item[];
  scrollId?: any;
}

interface Props {
  align: string;
  selected?: string;
  items: Item[];
  switchTabs?: (e: any) => void;
  disabled?: boolean;
  showSublinks?: boolean;
  showIcons?: boolean;
  variant?: string;
  className?: string;
}

const ListItem = props => (
  <li
    className={cx({
      [styles[props.align]]: true,
      [styles.active]: props.item.key === props.selected,
      [styles.disabled]: props.disabled,
      [styles['nested-li']]: props.subLink,
    })}
    data-tab={props.item.key}
    data-href={props.item.href}
    onClick={props.disabled ? () => null : props.switchTabs}
    id={(props.item.key || '').replace('/', '')}
  >
    {props.item.link ? (
      <Fragment>
        <Link prefetch route={props.item.href}>
          <a
            className={cx(styles['tab-link'], styles['sub-links'], {
              [styles.active]:
                props.item.selected || props.item.key === props.selected,
            })}
          >
            {props.item.icon && props.showIcons ? (
              <img
                className={cx(styles['tab-link-icons'])}
                src={props.item.icon}
              />
            ) : null}
            <span className={cx(styles['tab-link-label'])}>
              {props.item.label}
            </span>
            {props.subLink && props.item.status ? (
              <span>{props.item.status}</span>
            ) : null}
          </a>
        </Link>
      </Fragment>
    ) : (
      <a className={cx(styles['tab-link'])}>{props.item.label}</a>
    )}

    {props.item.loading ? <Loader noPadding={true} /> : null}
  </li>
);

const Tabs = ({
  align,
  selected,
  items,
  switchTabs,
  disabled,
  showSublinks,
  showIcons,
  variant,
  className,
}: Props) => (
  <div style={{ height: 'inherit' }}>
    <ul className={cx(styles[align], styles[variant], styles[className])}>
      {items.map((item, i) => {
        return (
          <Fragment key={`${item.label}_${item.href}_fragment_${i}`}>
            <ListItem
              align={align}
              disabled={disabled}
              selected={selected}
              switchTabs={switchTabs}
              item={item}
              showIcons={showIcons}
            />
            {showSublinks ? (
              <Fragment>
                {item.subLinksLoading ? (
                  <ul key="loading_ul" className={styles['nested-ul']}>
                    <li
                      className={cx({
                        [styles['vertical']]: true,
                        [styles['nested-li']]: true,
                      })}
                    >
                      <span className="text--sm font--grey block text-center pt10">
                        Fetching pending actions
                      </span>
                      <Loader />
                    </li>
                  </ul>
                ) : null}
                {item.key === '/dashboard' &&
                !item.subLinksLoading &&
                item.subLinks &&
                !item.subLinks.length ? (
                  <ul key="loading_ul" className={styles['nested-ul']}>
                    <li
                      className={cx({
                        [styles['vertical']]: true,
                        [styles['nested-li']]: true,
                      })}
                    >
                      <span className="text--sm font--grey block text-center pt10 pb10">
                        No Pending actions
                      </span>
                    </li>
                  </ul>
                ) : null}
                {item.subLinks ? (
                  <ul
                    key={`${item.label}_${item.href}_ul`}
                    className={styles['nested-ul']}
                  >
                    {(item.subLinks || []).map(subItem => {
                      return (
                        <ListItem
                          align={align}
                          key={`${subItem.label}_${subItem.href}_listItem`}
                          disabled={disabled}
                          selected={selected}
                          switchTabs={switchTabs}
                          item={subItem}
                          subLink
                        />
                      );
                    })}
                  </ul>
                ) : null}
              </Fragment>
            ) : null}
          </Fragment>
        );
      })}
    </ul>
  </div>
);

export default Tabs;



// WEBPACK FOOTER //
// ./components/ui/tabs.tsx